var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'bottom-wrapper',
    {
      'is-fixed': !_vm.isEditorStatus,
      'no-img': !_vm.property_data.image_url,
    } ],style:({
    paddingLeft: _vm.property_data.margin + 'px',
    paddingRight: _vm.property_data.margin + 'px',
    bottom: _vm.property_data.distance + 'px',
    paddingBottom: _vm.isEditorStatus ? _vm.property_data.distance + 'px' : 0,
  })},[(_vm.property_data.image_url)?_c('img',{ref:"bottomImg",staticClass:"bottom-img",style:({
      borderRadius: _vm.property_data.radius + 'px',
    }),attrs:{"src":_vm.property_data.image_url,"alt":"bottom"},on:{"click":function($event){_vm.jump(_vm.config.link_data[0].link_data)}}}):_c('img',{staticClass:"bottom-no-img",attrs:{"src":"https://img.mockuai.com/tms/2018/1/13/upload_ed4e75f3608d59cbd803c5e3a98960af.png","alt":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }